<svg
  *ngIf="unpinned; else pinned"
  class="svg"
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  (click)="pin()"
>
  <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="black" />
  <path
    d="M11.076 16.1499L9.68313 18.5624"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M15.731 18.1877C15.9598 17.497 15.9095 16.7442 15.5908 16.09C15.5617 16.0286 15.5464 15.9616 15.5461 15.8937C15.5458 15.8258 15.5603 15.7586 15.5888 15.6969L18.1596 10.0001C18.2069 9.89519 18.2136 9.77639 18.1783 9.6668C18.143 9.55721 18.0682 9.46464 17.9685 9.40708L13.4692 6.80938C13.3695 6.75181 13.2519 6.73335 13.1394 6.75757C13.0268 6.78179 12.9273 6.84697 12.86 6.94046L9.21186 12.0152C9.17268 12.0707 9.12179 12.1169 9.0628 12.1506C9.0038 12.1842 8.93814 12.2045 8.87044 12.21C8.14458 12.2611 7.46744 12.5939 6.98365 13.1375C6.93732 13.1889 6.90304 13.2501 6.88332 13.3165C6.8636 13.3829 6.85893 13.4528 6.86965 13.5213C6.88037 13.5897 6.90621 13.6548 6.94529 13.712C6.98437 13.7692 7.03571 13.817 7.09556 13.8518L15.0564 18.448C15.1165 18.4824 15.1835 18.503 15.2526 18.5082C15.3216 18.5135 15.391 18.5033 15.4556 18.4784C15.5202 18.4534 15.5785 18.4144 15.6261 18.3641C15.6738 18.3139 15.7096 18.2536 15.731 18.1877Z"
    fill="black"
    stroke="black"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<ng-template #pinned>
  <svg
    class="svg"
    (click)="unpin()"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="black" />
    <path
      d="M11.2504 16.031L9.9379 18.3043"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.4133 15.8029L17.9254 10.2361C17.97 10.1372 17.9763 10.0253 17.943 9.922C17.9098 9.81873 17.8393 9.73151 17.7454 9.67726L13.5404 7.24951"
      fill="black"
    />
    <path
      d="M15.4133 15.8029L17.9254 10.2361C17.97 10.1372 17.9763 10.0253 17.943 9.922C17.9098 9.81873 17.8393 9.73151 17.7454 9.67726L13.5404 7.24951L15.4133 15.8029Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0413 8.59114L9.49385 12.1348C9.45693 12.187 9.40898 12.2306 9.35339 12.2623C9.2978 12.294 9.23592 12.3131 9.17213 12.3183C8.48814 12.3664 7.85007 12.6801 7.39419 13.1922C7.35053 13.2407 7.31823 13.2984 7.29965 13.3609C7.28107 13.4235 7.27667 13.4894 7.28677 13.5539C7.29687 13.6184 7.32122 13.6798 7.35805 13.7337C7.39487 13.7875 7.44324 13.8325 7.49965 13.8654L14.006 17.6218"
      fill="black"
    />
    <path
      d="M12.0413 8.59114L9.49385 12.1348C9.45693 12.187 9.40898 12.2306 9.35339 12.2623C9.2978 12.294 9.23592 12.3131 9.17213 12.3183C8.48814 12.3664 7.85007 12.6801 7.39419 13.1922C7.35053 13.2407 7.31823 13.2984 7.29965 13.3609C7.28107 13.4235 7.27667 13.4894 7.28677 13.5539C7.29687 13.6184 7.32122 13.6798 7.35805 13.7337C7.39487 13.7875 7.44324 13.8325 7.49965 13.8654L14.006 17.6218"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3686 5.49048L14.6322 20.5095"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>
